import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const reviews = [
  { name: "Marco R.", tag: "Fibra + Mobile", text: "Mi hanno trovato un'offerta fibra ottima e attivato tutto in pochi giorni. Personale super disponibile." },
  { name: "Giulia B.", tag: "Smartphone nuovo", text: "Comprato il telefono nuovo con trasferimento dati incluso. Zero stress, tutto pronto all'uscita dal negozio." },
  { name: "Antonio P.", tag: "Luce e Gas", text: "Bolletta più bassa grazie al loro confronto. Spiegazioni chiare, nessuna sorpresa." },
  { name: "Sara M.", tag: "Usato garantito", text: "Preso un ricondizionato garantito, come nuovo e a metà prezzo. Consigliatissimi." },
  { name: "Luca D.", tag: "Assistenza", text: "Avevo un problema di configurazione, risolto in 10 minuti senza appuntamento. Fantastici." },
  { name: "Elena V.", tag: "Offerta mobile", text: "Finalmente qualcuno che ti consiglia davvero e non ti vende il pacchetto più caro." },
];

const Card = ({ r }) => (
  <div className="w-[20rem] shrink-0 rounded-3xl bg-white border border-neutral-100 p-7 shadow-sm">
    <div className="flex text-brand mb-4">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" />)}
    </div>
    <p className="text-neutral-700 leading-relaxed">{r.text}</p>
    <div className="mt-6 flex items-center gap-3">
      <div className="w-11 h-11 rounded-full bg-ink text-white flex items-center justify-center font-display font-bold">
        {r.name.charAt(0)}
      </div>
      <div>
        <p className="font-semibold text-sm">{r.name}</p>
        <p className="text-xs text-neutral-400">{r.tag}</p>
      </div>
    </div>
  </div>
);

export const Reviews = () => (
  <section id="recensioni" data-testid="reviews-section" className="bg-[#FAFAFA] py-24 md:py-32 border-y border-neutral-100 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-bold text-brand">Recensioni</p>
          <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-3">
            Più di 1000 clienti soddisfatti
          </h2>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex text-brand">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" />)}
          </div>
          <span className="font-display font-bold text-2xl">5,0</span>
        </div>
      </Reveal>
    </div>

    <div className="mt-14 marquee-pause relative">
      <div className="flex gap-5 w-max animate-marquee px-6">
        {[...reviews, ...reviews].map((r, i) => <Card key={i} r={r} />)}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#FAFAFA] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#FAFAFA] to-transparent" />
    </div>
  </section>
);
